export default __webpack_public_path__ + "static/BrandGuidelineThumbnail-33dc0162a7e5f5e8b87623605debae25.png";